<template>
  <div class="c--bottom_banner position-relative bottom-banner-image-ratio box-rounded-big shadowed overflow-hidden">
    <div class="centered-xy w-100 h-100">
      <nuxt-img :src="imageUrl" alt="" width="1120" height="408" loading="lazy" class="centered-xy md:tw-w-full" />
    </div>
    <template v-if="$slots.default">
      <div class="centered-xy w-100">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bottom-banner {
    &-image {
      &-ratio {
        padding-top: 0;
        height: 408px;

        img {
          object-fit: cover;
          height: 100%;
        }
      }
    }
  }
</style>
